import type { DashboardWidgetConfiguration } from './widget-definition';
import { yearToDate } from './query-period';

export const financeQuarterlyRevenueProfitWidget: DashboardWidgetConfiguration = {
  widgetId: 'finance.quarterly-revenue-profit', name: 'Quarterly revenue and net profit',
  description: 'Calendar year-to-date posted revenue and net profit, grouped by accounting quarter. Revenue excludes taxes; net profit includes posted income and expenses.',
  apps: ['finance'], template: 'graph',
  query: {kind: 'graph', valueQuery: {
    version: 1, source: 'finance.posted-journal-items', ...yearToDate(),
    select: [{type:'aggregate',function:'sum',field:'balance',as:'profit'}],
    where: {type:'group',operator:'or',children:[
      {type:'condition',field:'account_type',operator:'starts_with',value:'income'},
      {type:'condition',field:'account_type',operator:'starts_with',value:'expense'},
    ]},
  }, graphQueries: [
    {name:'Revenue',type:'bar',color:'#206bc4',lineWidth:0,valueMultiplier:-1,query:{
      version:1,source:'finance.posted-journal-items',...yearToDate(),
      select:[{type:'field',field:'accounting_date',bucket:'quarter',as:'quarter'},
        {type:'aggregate',function:'sum',field:'balance',as:'revenue'}],
      group_by:[{field:'accounting_date',bucket:'quarter'}],order_by:[{ref:'quarter',direction:'asc'}],
      where:{type:'condition',field:'account_type',operator:'starts_with',value:'income'},
    }},
    {name:'Net profit',type:'bar',color:'#2fb344',lineWidth:0,valueMultiplier:-1,query:{
      version:1,source:'finance.posted-journal-items',...yearToDate(),
      select:[{type:'field',field:'accounting_date',bucket:'quarter',as:'quarter'},
        {type:'aggregate',function:'sum',field:'balance',as:'profit'}],
      group_by:[{field:'accounting_date',bucket:'quarter'}],order_by:[{ref:'quarter',direction:'asc'}],
      where:{type:'group',operator:'or',children:[
        {type:'condition',field:'account_type',operator:'starts_with',value:'income'},
        {type:'condition',field:'account_type',operator:'starts_with',value:'expense'},
      ]},
    }},
  ]},
  inputs:{title:'Quarterly revenue and net profit',valueFormat:'currency',valueMultiplier:-1,
    graphPadding:true,chartHeight:250,showAxes:true,showTimeWindowPicker:false,fixedTimeWindowLabel:'Calendar year to date'},
  dummyData:{value:'Net profit',series:[18,24,20,32]},
  limits:{minWidth:6,maxWidth:12,minHeight:4,maxHeight:7,defaultWidth:12,defaultHeight:5},
};
